import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, DatePicker, Row, Col, Input, Drawer, Space, TreeSelect } from 'antd';
import { Form } from '@ant-design/compatible';
import { isMobile } from 'react-device-detect';
import { manualTelesaleResult, getTelesaleFollowUpsByCustomer } from '@/redux/actions/telesaleFollowUpActions';
import BaseSelect from '@/components/Elements/BaseSelect';
import { fetchActiveCustomers } from '@/redux/actions/customerActions';
import moment from 'moment';
import { makeTree, telesaleFollowStatuses } from '@/utils/helpers';
import { fetchFilters } from '@/redux/actions/filterActions';
import { SaveOutlined, UserOutlined } from '@ant-design/icons';

// Form dành cho nhân viên telesale tự cập nhật kết quả telesale khi chưa có bản ghi được phân công
class TelesaleManualResultForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            customerQuery: ''
        }
    }

    componentDidMount() {
        this.props.fetchActiveCustomers();
        this.props.fetchFilters();
    }

    async handleCreate(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true })
                try {
                    // Trường trả kết quả từ trang chi tiết khách hàng
                    if (this.props.customer) values.customer_id = this.props.customer.id;

                    values.handled_at = values.handled_at ? values.handled_at.format("YYYY-MM-DD HH:mm") : null;
                    await this.props.manualTelesaleResult(values);
                    this.props.loadData();
                    this.onCancel()
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onSearchCustomer(val) {
        this.setState({ customerQuery: val }, () => {
            this.props.fetchActiveCustomers({ keyword: val });
        })
    }

    handleCustomerScroll(e) {
        this.props.fetchActiveCustomers({ keyword: this.state.customerQuery, page: this.props.pagination_active.currentPage + 1 });
    }

    onCancel() {
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({ isLoading: false, customerQuery: '' });
        this.onSearchCustomer('');
    }

    async onSelectCustomer(customerId) {
        if (!customerId) return;

        try {
            const list = await this.props.getTelesaleFollowUpsByCustomer(customerId);

            if (!Array.isArray(list) || !list.length) return;

            // Vì backend đã sort DESC → bản ghi mới nhất ở đầu
            const latestTelesale = list.find(
                item => item.care_type === 'telesale'
            );

            if (!latestTelesale) return;

            const { setFieldsValue, getFieldValue } = this.props.form;

            const payload = {};

            if (!getFieldValue('service_id') && latestTelesale.service_id) {
                payload.service_id = latestTelesale.service_id;
            }

            if (!getFieldValue('follow_status') && latestTelesale.follow_status) {
                payload.follow_status = latestTelesale.follow_status;
            }

            if (!getFieldValue('telesale_note') && latestTelesale.note) {
                payload.telesale_note = latestTelesale.note;
            }

            // Optional: fill kết quả cũ
            // if (!getFieldValue('result_content') && latestTelesale.result_content) {
            //     payload.result_content = latestTelesale.result_content;
            // }

            if (Object.keys(payload).length) {
                setFieldsValue(payload);
            }

        } catch (err) {
            console.error('onSelectCustomer error', err);
        }
    }


    render() {
        var { customerActiveList, visible, filterData, customer } = this.props;
        var { isLoading } = this.state;
        const { getFieldDecorator } = this.props.form;

        const service = makeTree(filterData?.services || [], 0);

        return (
            <div>
                <Drawer
                    title="Trả kết quả telesale"
                    visible={visible}
                    header={false}
                    width={isMobile ? '100%' : '50%'}
                    onClose={() => this.onCancel()}
                    maskClosable={false}
                    footer={
                        <div style={{ textAlign: 'right', }}>
                            <Space>
                                <Button key="back" size='large' onClick={() => this.onCancel()}>
                                    Huỷ
                                </Button>
                                <Button
                                    loading={isLoading}
                                    key="submit"
                                    type="primary"
                                    onClick={(e) => this.handleCreate(e)}
                                    icon={<SaveOutlined />}
                                    size='large'
                                >
                                    Lưu
                                </Button>
                            </Space>
                        </div>
                    }
                >
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            {
                                customer ? (
                                    <Col xs={24} className='mb-4'>
                                        <h6>
                                            <UserOutlined /> Khách hàng:{' '}
                                            <span className="color-primary">
                                                {customer?.full_name} - {customer?.code}
                                            </span>
                                        </h6>
                                    </Col>
                                ) : (
                                    <Col xs={24} md={24}>
                                        <Form.Item label="Khách hàng">
                                            {getFieldDecorator("customer_id", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Vui lòng chọn!",
                                                    },
                                                ],
                                                initialValue: null
                                            })(
                                                <BaseSelect
                                                    options={customerActiveList || []}
                                                    optionValue="id"
                                                    optionLabel="full_name"
                                                    additionalLabel="phone"
                                                    additionalLabel2="code"
                                                    isCustomerList={true}
                                                    showSearch
                                                    placeholder="Mã, tên, 3 số cuối sđt của khách hàng"
                                                    onSearch={(val) => this.onSearchCustomer(val)}
                                                    onScrollEnd={(e) => this.handleCustomerScroll(e)}
                                                    className="w-100"
                                                    onChange={(val) => this.onSelectCustomer(val)}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                )
                            }

                            <Col xs={24} md={24}>
                                <Form.Item label="Dịch vụ quan tâm">
                                    {getFieldDecorator('service_id', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: null
                                    })(
                                        <TreeSelect
                                            showSearch
                                            className="w-100"
                                            dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                            treeData={service || []}
                                            treeNodeFilterProp='title'
                                            allowClear
                                            placeholder="Dịch vụ quan tâm"
                                            treeDefaultExpandAll
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Thời điểm telesale">
                                    {getFieldDecorator('handled_at', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: moment()
                                    })(
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            showTime={{ format: 'HH:mm' }}
                                            format="DD/MM/YYYY HH:mm"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Trạng thái follow">
                                    {getFieldDecorator('follow_status', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: null
                                    })(
                                        <BaseSelect
                                            options={telesaleFollowStatuses || []}
                                            optionValue="value"
                                            optionLabel="label"
                                            placeholder="Trạng thái follow"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Kết quả telesale">
                                    {getFieldDecorator('result_content', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: null
                                    })(
                                        <Input.TextArea rows={10} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('telesale_note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: null
                                    })(
                                        <Input.TextArea rows={3} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Drawer>
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        customerActiveList: state.customerReducer.activeList.items,
        pagination_active: state.customerReducer.activeList.pagination,
        filterData: state.filterReducer.list,
        users: state.config.users
    }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchActiveCustomers: (filter) => dispatch(fetchActiveCustomers(filter)),
        manualTelesaleResult: (data) => dispatch(manualTelesaleResult(data)),
        getTelesaleFollowUpsByCustomer: (customer_id) => dispatch(getTelesaleFollowUpsByCustomer(customer_id)),
        fetchFilters: () => dispatch(fetchFilters())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'TelesaleManualResultForm' })(TelesaleManualResultForm));

